import { RootState } from "src/app/store";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { MessageStatusError } from "src/util/MessageStatus";
import { removeCookieValue } from "src/util/Commom";
import configUrl from "src/util/config";
import getMeInfo from "./ApiMe";

export const fetchUseMe = createAsyncThunk(
  "userInfo",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getMeInfo(); // Gọi API lấy thông tin người dùng hiện tại
      return response?.data; // Trả về dữ liệu từ response
    } catch (error) {
      MessageStatusError(401);
      removeCookieValue("accessTokenTVDTBDT");
      setTimeout(() => {
        window.location.href = `${configUrl.API_URL}/saml/logout?url=${window.location.protocol}//${window.location.host}${window.location.hash}`;
      }, 1500);
      return rejectWithValue(error); // Trả về lỗi nếu gặp vấn đề
    }
  }
);

interface AuthState {
  userMe: any | null;
  isLoggedIn: boolean;
  error: string | null;
}

const initialState: AuthState = {
  userMe: null,
  isLoggedIn: false,
  error: null,
};

const authSlice = createSlice({
  name: "userInfo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUseMe.pending, (state) => {
        state.isLoggedIn = true;
        state.error = null;
      })
      .addCase(
        fetchUseMe.fulfilled,
        (state, action: PayloadAction<unknown>) => {
          state.isLoggedIn = false;
          state.userMe = action.payload;
        }
      )
      .addCase(fetchUseMe.rejected, (state, action: PayloadAction<any>) => {
        state.isLoggedIn = false;
        state.error = action.payload;
      });
  },
});

export const selectUser = (state: RootState) => state.useInfo.userMe;

export default authSlice.reducer;
